import { UserRole } from "constants/userRole";
import { useUserWithAccount } from "context/UserAccountProvider";
import useDocumentTitle from "hooks/useDocumentTitle";
import { TabPanel, TabView } from "primereact/tabview";

import { PlineReconciliation } from "./component/PlineReconciliation";
import { ReportsTable } from "./component/ReportsTable";

export function Reports() {
  useDocumentTitle("List Reports");
  const { userInfo } = useUserWithAccount();
  const isSuperAdmin = userInfo?.scope === UserRole.SUPER_ADMIN;

  return (
    <TabView className="w-full">
      <TabPanel header="Reporting">
        <ReportsTable />
      </TabPanel>
      {/* CLE-2917: SuperAdmin-only (the /reports route is SuperAdmin-only too; this is the second gate). */}
      {isSuperAdmin && (
        <TabPanel header="P-line reconciliation">
          <PlineReconciliation />
        </TabPanel>
      )}
    </TabView>
  );
}
